const REQUEST_LIVE_UPDATE = '@@liveUpdates/REQUEST_LIVE_UPDATE';
const LIVE_UPDATE_RESPONSE = '@@liveUpdates/LIVE_UPDATE_RESPONSE';

export default {
	REQUEST_LIVE_UPDATE,
	LIVE_UPDATE_RESPONSE,
};